'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _require = require('uint8arrays/concat'),
    concat = _require.concat;

var _require2 = require('uint8arrays/from-string'),
    fromString = _require2.fromString;

var webcrypto = require('../webcrypto'); // Based off of code from https://github.com/luke-park/SecureCompatibleEncryptionExamples

/**
 *
 * @param {object} [options]
 * @param {string} [options.algorithm=AES-GCM]
 * @param {number} [options.nonceLength=12]
 * @param {number} [options.keyLength=16]
 * @param {string} [options.digest=sha256]
 * @param {number} [options.saltLength=16]
 * @param {number} [options.iterations=32767]
 * @returns {*}
 */


function create() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$algorithm = _ref.algorithm,
      algorithm = _ref$algorithm === void 0 ? 'AES-GCM' : _ref$algorithm,
      _ref$nonceLength = _ref.nonceLength,
      nonceLength = _ref$nonceLength === void 0 ? 12 : _ref$nonceLength,
      _ref$keyLength = _ref.keyLength,
      keyLength = _ref$keyLength === void 0 ? 16 : _ref$keyLength,
      _ref$digest = _ref.digest,
      digest = _ref$digest === void 0 ? 'SHA-256' : _ref$digest,
      _ref$saltLength = _ref.saltLength,
      saltLength = _ref$saltLength === void 0 ? 16 : _ref$saltLength,
      _ref$iterations = _ref.iterations,
      iterations = _ref$iterations === void 0 ? 32767 : _ref$iterations;

  var crypto = webcrypto.get();
  keyLength *= 8; // Browser crypto uses bits instead of bytes

  /**
   * Uses the provided password to derive a pbkdf2 key. The key
   * will then be used to encrypt the data.
   *
   * @param {Uint8Array} data - The data to decrypt
   * @param {string} password - A plain password
   * @returns {Promise<Uint8Array>}
   */

  function encrypt(_x, _x2) {
    return _encrypt.apply(this, arguments);
  }
  /**
   * Uses the provided password to derive a pbkdf2 key. The key
   * will then be used to decrypt the data. The options used to create
   * this decryption cipher must be the same as those used to create
   * the encryption cipher.
   *
   * @param {Uint8Array} data - The data to decrypt
   * @param {string} password - A plain password
   * @returns {Promise<Uint8Array>}
   */


  function _encrypt() {
    _encrypt = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data, password) {
      var salt, nonce, aesGcm, deriveParams, rawKey, cryptoKey, ciphertext;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // eslint-disable-line require-await
              salt = crypto.getRandomValues(new Uint8Array(saltLength));
              nonce = crypto.getRandomValues(new Uint8Array(nonceLength));
              aesGcm = {
                name: algorithm,
                iv: nonce
              }; // Derive a key using PBKDF2.

              deriveParams = {
                name: 'PBKDF2',
                salt: salt,
                iterations: iterations,
                hash: {
                  name: digest
                }
              };
              _context.next = 6;
              return crypto.subtle.importKey('raw', fromString(password), {
                name: 'PBKDF2'
              }, false, ['deriveKey', 'deriveBits']);

            case 6:
              rawKey = _context.sent;
              _context.next = 9;
              return crypto.subtle.deriveKey(deriveParams, rawKey, {
                name: algorithm,
                length: keyLength
              }, true, ['encrypt']);

            case 9:
              cryptoKey = _context.sent;
              _context.next = 12;
              return crypto.subtle.encrypt(aesGcm, cryptoKey, data);

            case 12:
              ciphertext = _context.sent;
              return _context.abrupt("return", concat([salt, aesGcm.iv, new Uint8Array(ciphertext)]));

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _encrypt.apply(this, arguments);
  }

  function decrypt(_x3, _x4) {
    return _decrypt.apply(this, arguments);
  }

  function _decrypt() {
    _decrypt = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(data, password) {
      var salt, nonce, ciphertext, aesGcm, deriveParams, rawKey, cryptoKey, plaintext;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              salt = data.slice(0, saltLength);
              nonce = data.slice(saltLength, saltLength + nonceLength);
              ciphertext = data.slice(saltLength + nonceLength);
              aesGcm = {
                name: algorithm,
                iv: nonce
              }; // Derive the key using PBKDF2.

              deriveParams = {
                name: 'PBKDF2',
                salt: salt,
                iterations: iterations,
                hash: {
                  name: digest
                }
              };
              _context2.next = 7;
              return crypto.subtle.importKey('raw', fromString(password), {
                name: 'PBKDF2'
              }, false, ['deriveKey', 'deriveBits']);

            case 7:
              rawKey = _context2.sent;
              _context2.next = 10;
              return crypto.subtle.deriveKey(deriveParams, rawKey, {
                name: algorithm,
                length: keyLength
              }, true, ['decrypt']);

            case 10:
              cryptoKey = _context2.sent;
              _context2.next = 13;
              return crypto.subtle.decrypt(aesGcm, cryptoKey, ciphertext);

            case 13:
              plaintext = _context2.sent;
              return _context2.abrupt("return", new Uint8Array(plaintext));

            case 15:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return _decrypt.apply(this, arguments);
  }

  return {
    encrypt: encrypt,
    decrypt: decrypt
  };
}

module.exports = {
  create: create
};